import React, {useState, useEffect} from "react";
import { Button, List, Toast,DatePicker } from "antd-mobile";
import instance from "../../../../util/axios";
import DictionarySelect from "../../../../component/CheckBoxItem";
import moment from "moment";
interface InputFields {
  isReturning?: string;
  otherWorkshop?: string;
  workshopId?: string;
  procedureId?: string;
  remarkId?: string;
  staffId?: string;
  orderCalType?: string;
  useGroup?: string;
  groupId?: string;
  joinedStaffsId?: string;
  workDate?: any;
  submitId?: any;
}
export default function CompletionHome() {
  const [completionHome, setCompletionHome] = useState<InputFields>({});
  const [procedureFilter, setProcedureFilter] = useState<string>("");
  const [remarkFilter, setRemarkFilter] = useState<string>("");
  const [staffFilter, setStaffFilter] = useState<string>("");
  const [groupFilter, setGroupFilter] = useState<string>("");
  useEffect(() => {
      instance.get(`/erp/workshop/getWorkshopDeptByUser`).then((resp) => {
          if(resp.data.Status === "1" && resp.data.Data){
              if(resp.data.Data.workshopId){
                  setProcedureFilter(" workshopId like '"+ resp.data.Data.workshopId +"'");
                  setGroupFilter(" workshopId='"+ resp.data.Data.workshopId +"'");
              }
              if(resp.data.Data.departmentIds){
                  setStaffFilter(" find_in_set(departmentId,'"+ resp.data.Data.departmentIds +"')>0");
              }
          }
      });

        instance.get(`/erp/user/getUserPermission`).then((resp) => {
            if(resp.data.Status === "1"){
                const allPermissions = resp.data.Data;
                if(allPermissions.indexOf("代理填报工量") === -1){
                    instance.get(`/crm/user/`).then((res) => {
                        setCompletionHome({
                            isReturning: "2",
                            otherWorkshop: "2",
                            procedureId: "",
                            remarkId: "",
                            staffId: res.data.Data && res.data.Data.uuid ? res.data.Data.uuid : "",
                            orderCalType: "",
                            useGroup: "",
                            groupId: "",
                            joinedStaffsId: "",
                            workDate: "",
                        });
                    });
                }else{
                    setCompletionHome({
                        isReturning: "2",
                        otherWorkshop: "2"
                    });
                }
            }else{
                setCompletionHome({
                    isReturning: "2",
                    otherWorkshop: "2"
                });
            }
        });
  }, []);

  return (
    <>
      <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
     <div>
          <List>
              <DictionarySelect
                  title={"返修填报"}
                  multiple={false}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.isReturning}
                  onChange={(value) => {
                      setCompletionHome((prevState) => ({
                          ...prevState,
                          isReturning: value,
                      }));
                  }}
              />
          </List>
          <List>
              <DictionarySelect
                  title={"车间帮工"}
                  multiple={false}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.otherWorkshop}
                  onChange={(value) => {
                      setCompletionHome((prevState) => ({
                          ...prevState,
                          otherWorkshop: value,
                      }));
                  }}
              />
          </List>
          {completionHome.otherWorkshop === "1"
           && (<><List>
              <DictionarySelect
                  title={"选择车间"}
                  multiple={false}
                  dictionary={"erp_workshop"}
                  value={completionHome.workshopId}
                  onChange={(value) => {
                      setCompletionHome((prevState) => ({
                          ...prevState,
                          workshopId: value,
                      }));
                      setProcedureFilter(" workshopId like '"+ value +"'");
                  }}
              />
          </List></>)}
        <List>
          <DictionarySelect
            title={"工序"}
            multiple={false}
            dictionary={"erp_procedure"}
            originFilter={procedureFilter}
            value={completionHome.procedureId}
            onChange={(value) => {
              setCompletionHome((prevState) => ({
                ...prevState,
                procedureId: value,
                remarkId: ""
              }));
              instance.post(`/erp/procedure/getRemarkIdsByProcedureId`, {procedureId: value}).then((resp) => {
                    if(resp.data.Status === "1" && resp.data.Data){
                        setRemarkFilter(" find_in_set(uuid,'"+ resp.data.Data +"')>0");
                    }
              });
            }}
          />
        </List>
      <List>
          <DictionarySelect
              title={"生产产品"}
              multiple={false}
              dictionary={"erp_remark_product"}
              originFilter={remarkFilter}
              value={completionHome.remarkId}
              onChange={(value) => {
                  setCompletionHome((prevState) => ({
                      ...prevState,
                      remarkId: value,
                  }));
              }}
          />
      </List>
        <List>
          <DictionarySelect
            title={"填报人"}
            multiple={false}
            dictionary={"base_staff"}
            originFilter={staffFilter}
            value={completionHome.staffId}
            onChange={(value) => {
              setCompletionHome((prevState) => ({
                ...prevState,
                staffId: value,
              }));
            }}
          />
        </List>
        <List>
          <DictionarySelect
            title={"类型"}
            multiple={false}
            dictionary={"dict_order_production_cal_type"}
            value={completionHome.orderCalType}
            onChange={(value) => {
              setCompletionHome((prevState) => ({
                ...prevState,
                orderCalType: value,
              }));
              if (value !== '2') {
                setCompletionHome((prevState) => ({
                  ...prevState,
                  useGroup: '',
                  groupId: '',
                  joinedStaffsId: '',
                }));
              }
            }}
          />
        </List>
        <List>
        <DatePicker
          mode="date"
          title="选择日期"
          value={completionHome.workDate ? new Date(completionHome.workDate) : undefined}
          onChange={(value: any) =>
            setCompletionHome((prevState) => ({
              ...prevState,
              workDate: moment(value).format("YYYY-MM-DD"),
            }))
          }>
          <List.Item arrow="horizontal">
          工作日期
          </List.Item>
        </DatePicker>
        </List>
          <List>
              <DictionarySelect
                  title={"使用已有组别"}
                  multiple={false}
                  disabled={completionHome.orderCalType !== "2"}
                  dictionary={"dict_order_free_bool"}
                  value={completionHome.useGroup}
                  onChange={(value) => {
                      setCompletionHome((prevState) => ({
                          ...prevState,
                          useGroup: value,
                      }));
                      if(value !== "1"){
                          setCompletionHome((prevState) => ({
                              ...prevState,
                              groupId: "",
                          }));
                      }
                  }}
              />
          </List>
          <List>
              <DictionarySelect
                  title={"选择组名称"}
                  multiple={false}
                  dictionary={"erp_work_group"}
                  originFilter={groupFilter}
                  disabled={completionHome.orderCalType !== "2" || completionHome.useGroup !== "1"}
                  value={completionHome.groupId}
                  onChange={ async (value) => {
                      setCompletionHome((prevState) => ({
                          ...prevState,
                          groupId: value,
                      }));
                      if (value) {
                          const resp = await instance.post(`/erp/sku/workshop/getWorkGroupById`, {uuid: value});
                          if(resp.data.Status === "1" && resp.data.Data){
                              setCompletionHome((prevState) => ({
                                  ...prevState,
                                  joinedStaffsId: resp.data.Data.staffIds || "",
                              }));
                          }
                      }
                  }}
              />
          </List>
        <List>
          <DictionarySelect
            title={"参与员工"}
            multiple={true}
            disabled={completionHome.orderCalType !== "2"}
            dictionary={"base_staff"}
            originFilter={staffFilter}
            value={completionHome.joinedStaffsId}
            onChange={(value) => {
              setCompletionHome((prevState) => ({
                ...prevState,
                joinedStaffsId: value,
              }));
            }}
          />
        </List>
        </div>
        <Button
          type="primary"
          style={{width: "100%",zIndex: 99 }}
          onClick={() => {
            if(completionHome.procedureId === undefined || completionHome.procedureId === "") {
              Toast.fail("请填写要填报的工序！");
              return;
            }
            if(completionHome.remarkId === undefined || completionHome.remarkId === "") {
              Toast.fail("请填写要填报的生产产品！");
              return;
            }
            if(completionHome.staffId === undefined || completionHome.staffId === "") {
              Toast.fail("请填写要填报的员工！");
              return;
            }
            if(completionHome.orderCalType === undefined || completionHome.orderCalType === "") {
              Toast.fail("请填写要填报的类型！");
              return;
            }
            if(completionHome.workDate === undefined || completionHome.workDate === "") {
              Toast.fail("请填写要工作日期！");
              return;
            }
            if(completionHome.orderCalType === "2" && !completionHome.joinedStaffsId) {
               Toast.fail("集体计件请选择参与员工！");
               return;
            }
            let baseConfigValue = "";
            let isCutting = "false";
            instance
              .post(`oa/base/phone/getBaseConfig`,{
                name:"下料工序"
              })
              .then((resp) => {
                if (resp.data.Status === "1") {
                  baseConfigValue = resp.data.Data?.value;

                  if (baseConfigValue.includes(completionHome.procedureId!)) {
                    isCutting = "true"
                  }

                  window.location.href = "/erp/completion?procedureId=" + completionHome.procedureId
                      + "&staffId=" + completionHome.staffId
                      + "&orderCalType=" + completionHome.orderCalType
                      + "&joinedStaffsId=" + completionHome.joinedStaffsId
                      + "&isReturning=" + completionHome.isReturning
                      + "&isOther=" + completionHome.otherWorkshop
                      + "&workshopId=" + (completionHome.workshopId || "")
                      + "&remarkId=" + (completionHome.remarkId || "")
                      + "&isCutting=" + isCutting
                      + "&useGroup=" + (completionHome.useGroup || "")
                      + "&groupId=" + (completionHome.groupId || "")
                      + "&workDate=" + (completionHome.workDate || "")
                }
              });
          }}
        >
          确认
        </Button>
      </div>
    </>
  );
}
